import globals from '../../../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    root: {
        marginLeft: '0.5rem',
        maxWidth: '2.5rem',
        minWidth: '1.875rem',
        '&.Mui-disabled': {
            backgroundColor: '#A7A7A7'
        }
    }
});
